import React, { FC, useState } from "react";
import { Table, Tooltip } from "antd";
import { YhBox } from "@/components/YhBox";
import { useVrmPurchaseRoDetailsModel } from "../vrmBillPurchaseRoModel";
import { ColumnsType } from "antd/es/table"
import { IDetailList } from "../vrmBillPurchaseRoType";
import useNavModel, { RouterParamType } from '@/model/navModel';
export const TableBox: FC<RouterParamType> = () => {
    const {
        goToPurchaseDetail,
        detailLookList,
    } = useVrmPurchaseRoDetailsModel();
    const { getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const { branch } = detailsInfo
    const columns: ColumnsType<IDetailList> = [
        {
            title: '序号',
            width: 80,
            fixed: "left",
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            title: '配件编码',
            width: 120,
            dataIndex: 'materialCode',
            fixed: "left",
        }, {
            title: '配件名称',
            width: 120,
            dataIndex: 'materialName',
            fixed: "left",
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            title: '采购数量',
            width: 120,
            dataIndex: 'purchaseNum',
        }, {
            title: '采购单价',
            width: 120,
            dataIndex: 'purchasePrice',
        }, {
            title: '退货数量',
            width: 120,
            dataIndex: 'num',

        }, {
            title: '退货单价',
            width: 120,
            dataIndex: 'price',

        }, {
            title: '退货金额',
            width: 120,
            dataIndex: 'amount',
        }, {
            title: '采购单号',
            width: 120,
            dataIndex: 'purchaseCode',
            render: (t, r) => <Tooltip placement="topLeft" title={t} arrowPointAtCenter>
                <p className="ellipsis click-span" onClick={(e) => { e.stopPropagation(); goToPurchaseDetail(t, branch) }}>{t}
                </p></Tooltip>
        }, {
            title: '已退货数量',
            width: 120,
            dataIndex: 'preturnNum',
        }, {
            title: '仓库',
            width: 160,
            dataIndex: 'warehouseName',
        }, {
            title: '货位',
            width: 160,
            dataIndex: 'shelfCode',
        }, {
            title: '备注',
            width: 300,
            dataIndex: 'note',
        }
    ];



    return (
        <YhBox title="配件信息" style={{ marginBottom: "75px" }}>
            <Table
                rowClassName='editable-row yh-edit-table-tr'
                rowKey={record => record.materialCode as string}
                columns={columns}
                dataSource={detailLookList}
                pagination={false}

                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    )
}